import { createReducer, on } from '@ngrx/store';
import * as RuleEnginrActions from './rule-engine.action';
import { ruleEngineObj } from './createRule';

export const initialState: any = { ruleObj: ruleEngineObj };

const _ruleEngineReducer = createReducer(
  initialState,
  on(RuleEnginrActions.saveRuleEngineObj, (state, { ruleObj }) => {
    return {
      ...state,
      ruleObj
    };
  }),
  on(RuleEnginrActions.initializeDefaultRuleEngineObj, (state, { }) => {
    return initialState;
  })
);

export function ruleEngineReducer(state = initialState, action) {
  return _ruleEngineReducer(state, action);
}



